import React from 'react';
import{moneyFormatter} from '../library/FormatUtil';
import './ConfirmationSubTotal.css';

export default function ConfirmationSubTotal(props) {
  return (
    <>
      <tr className='tr--fees'>
        <td className='td--confirm-charges'>Total Charges</td>
        <td className='confirm--subtotal pr-2 text-end'>{moneyFormatter.format(props.confirmationData?.subTotalAmount)}</td>
        <td></td>
      </tr>
    </>
  )
}
